/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import { fetchRecipientBookListWithOccasions } from '../../../../../../../../apis/account-apis/RecipientBook-apis/fetchRecipientBookListWithOccasions';
import { useQuery } from 'react-query';

const useRecipientBookListRes = (contactId) => (
    useQuery(
    ["recipientBookList", contactId ],
    fetchRecipientBookListWithOccasions,
    {
        refetchOnWindowFocus: false,
        retry: false,
        enabled: !!contactId,
    },
));

export default useRecipientBookListRes;